import { motion } from 'framer-motion';
import { useInView } from 'react-intersection-observer';

export default function MotionReveal({
    children,
    delay = 0,
    duration = 0.75,
    direction = 'up',
    amount = 0.2,
    className = '',
    ...rest
}) {
    const { ref, inView } = useInView({
        triggerOnce: true,
        threshold: amount,
    });

    const variants = {
        hidden: {
            opacity: 0,
            y: direction === 'up' ? 40 : direction === 'down' ? -40 : 0,
            x: direction === 'left' ? 40 : direction === 'right' ? -40 : 0,
        },
        visible: {
            opacity: 1,
            y: 0,
            x: 0,
            transition: { duration, delay },
        },
    };

    return (
        <motion.div
            ref={ref}
            className={className}
            initial="hidden"
            animate={inView ? 'visible' : 'hidden'}
            variants={variants}
            {...rest}
        >
            {children}
        </motion.div>
    );
}